import React, { memo } from "react";
import { Modal, Button } from "antd";
import { ReactComponent as ExclamationIcon } from "../../../assets/Icons/ExclamationIcon.svg";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import "./DeleteCampaignModal.scss";

const DeleteCampaignModal = ({
  isOpen,
  onClose,
  onDelete,
  campaignId,
  loading,
  /* This dialog is shared with the call-scripts page, which deletes a
     script rather than a campaign. Defaults to the campaign wording so the
     campaign screens are untouched. */
  message,
  /* A caller passing its own message can pass its own supporting line too;
     the default one only shows alongside the default question. */
  note,
  confirmLabel = "Delete",
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      className="deleteCampaignModal"
    >
      <div className="deleteModalContent">
        <span className="deleteModalIcon">
          <ExclamationIcon />
        </span>

        <h3 className="main-content">
          {message || "Are you sure you want to delete this campaign?"}
        </h3>

        {(note || !message) && (
          <p className="deleteModalNote">
            {/* Voice, SMS and WhatsApp campaigns all use this dialog, so the
                default line stays neutral about what the campaign does. */}
            {note || "This cannot be undone."}
          </p>
        )}

        {/* Cancel sits first so the destructive action is never the default
            landing spot for a stray click. */}
        <div className="deleteModalActions">
          <NormalButton type="default" className="cancelBtn" onClick={onClose}>
            Cancel
          </NormalButton>
          <Button
            type="primary"
            danger
            className="deleteBtn"
            loading={loading}
            onClick={onDelete}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default memo(DeleteCampaignModal);
